import HomePageCmsContainer from "../../container/admin/home-page-cms";

const HomePageCms = () => {
    return <HomePageCmsContainer />;
};

export default HomePageCms;
